import React, { useState } from 'react';
import { 
  Box, 
  Typography, 
  Container, 
  Paper, 
  Tabs, 
  Tab,
  CssBaseline
} from '@mui/material';
import ExerciseModelTrainer from './ExerciseModelTrainer';
import ExerciseLibrary from './ExerciseLibrary';
import DarkTheme from './DarkTheme';
import './ExerciseTrainDashboard.css';
import './StyleReset.css';

function ExerciseTrainDashboard() {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <DarkTheme>
      <CssBaseline />
      <Box sx={{ bgcolor: '#121212', minHeight: '100vh', width: '100%' }} className="exerciseTrain-root">
        <Container maxWidth="lg" className="dashboard-container">
          <Typography variant="h4" component="h1" gutterBottom className="dashboard-title">
            Exercise Training Studio
          </Typography>
          
          <Paper className="main-content" sx={{ bgcolor: '#1e1e1e' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <Tabs 
                value={activeTab} 
                onChange={handleTabChange}
                textColor="primary"
                indicatorColor="primary"
                sx={{ 
                  bgcolor: '#1a1a1a', 
                  '& .MuiTabs-flexContainer': {
                    justifyContent: 'center'
                  }
                }}
              >
                <Tab label="Train Models" sx={{ color: activeTab === 0 ? '#4dabf5' : '#b3b3b3' }} />
                <Tab label="Exercise Library" sx={{ color: activeTab === 1 ? '#4dabf5' : '#b3b3b3' }} />
              </Tabs>
            </Box>
            
            <Box sx={{ p: 3, bgcolor: '#1e1e1e' }}>
              {activeTab === 0 && (
                <ExerciseModelTrainer />
              )}
              {activeTab === 1 && (
                <ExerciseLibrary />
              )}
            </Box>
          </Paper>
        </Container>
      </Box>
    </DarkTheme>
  );
}

export default ExerciseTrainDashboard;
